import React from 'react';
import EInvoiceAccessLayout from '../../../components/EInvoiceAccessLayout';
import { useRoleModuleLabel } from '../../../hooks/useRoleModuleLabel';
import { READ_DOCUMENT_REPORT } from '../../../constants/eInvoicePermissions';
import { DOCUMENT_REPORT_MODULE_KEY } from '../../settings/constants/roleModules';

export default function DocumentReportAccessLayout() {
  const title = useRoleModuleLabel(DOCUMENT_REPORT_MODULE_KEY);

  return <EInvoiceAccessLayout permission={READ_DOCUMENT_REPORT} title={title} />;
}
